export const PLATFORMS = {
  PAYMENT_RECEIPT: "payment_receipt",
  EVENT_TRACKER: "event_tracker",
  PASSPORT_TRACKER: "passport_tracker",
  NIYAZ_APPROVAL: "niyaaz_approval",
  PETTY_CASH: "petty_cash",
};

export const ROLES = {
  EVENT_TRACKER: {
    CREATOR: "creator",
    MUSHRIF: "mushrif",
    AMIL_SAHEB: "amil_saheb",
    OFFICE_STAFF: "office_staff",
    MANAGER: "manager",
    JOINT_SECRETARY: "joint_secretary",
    VIEWER: "viewer",
    VALIDATOR: "validator",
    MUSHRIFA_UMOOR_DAKHLIYAH: "mushrifa_umoor_dakhliyah",
    BHABISAAB: "bhabisaab",
    BHENSAAB: "bhensaab",
  },
  PAYMENT_RECEIPT: {
    CREATOR: "creator",
    APPROVER: "approver",
    TREASURER: "treasurer",
    SECRETARY: "secretary",
    ACCOUNTS: "accounts",
    VIEWER: "viewer",
    VIEWER_UMOOR: "viewer_umoor",
    COLLECTOR: "collector",
  },
  NIYAZ_APPROVAL: {
    CREATOR: "creator",
    MUSHRIF: "mushrif",
    TREASURER: "treasurer",
    SECRETARY: "secretary",
    ACCOUNTS: "accounts",
    VIEWER: "viewer",
    NIYAAZ_TEAM: "niyaaz_team",
  },
  PETTY_CASH: {
    CREATOR: "creator",
    APPROVER: "approver",
    MANAGER: "manager",
    CASHIER: "cashier"
  },
};
